import { Stack } from "@fluentui/react";
import { EditIcon } from "@fluentui/react-icons-mdl2";

import { Card } from "@/components/Shared/Card";
import { AccountType } from "@/modules/Accounts/types";
import { ITermDataDraft } from "@/modules/Terms/interfaces/ITerm.interface";
import { cpfCnpjFormatter } from "@/utils/FormatCPForCNPJ";
import { phoneNumberFormatter } from "@/utils/PhoneNumberFormatter";

interface DisplayAccountDataProps {
  termDataDraft: ITermDataDraft;
  editAction: (term: ITermDataDraft) => void;
}

export function DisplayTermDataDraft({
  termDataDraft,
  editAction
}: DisplayAccountDataProps): JSX.Element {
  return (
    <Card padding="2rem" borderRadius="0.75rem" margin="1rem 0 2rem 0">
      <Stack.Item style={{ display: "flex", justifyContent: "space-between" }}>
        <h3 className="ms-fontSize-16">
          Informações do Documento Complementar
        </h3>

        <EditIcon
          style={{ cursor: "pointer", fontSize: 18, color: "#395ca3" }}
          title="Editar Documento Complementar"
          onClick={() => {
            editAction(termDataDraft);
          }}
        />
      </Stack.Item>

      <Stack.Item>
        <strong>Nome/Razão Social:</strong>
        <Stack.Item>{termDataDraft.fullName}</Stack.Item>
      </Stack.Item>
      <Stack.Item>
        <strong>CPF/CNPJ:</strong>
        <Stack.Item>
          {cpfCnpjFormatter(termDataDraft.documentNumber)}
        </Stack.Item>
      </Stack.Item>
      {termDataDraft.accountType === AccountType.LEGAL && (
        <Stack.Item>
          <strong>Representante Legal:</strong>{" "}
          <Stack.Item>
            Nome: {termDataDraft.legalRepresentativeName} - Documento:{" "}
            {termDataDraft.legalRepresentativeDocument}
          </Stack.Item>
        </Stack.Item>
      )}
      <Stack.Item>
        <strong>Telefone:</strong>{" "}
        <Stack.Item>{phoneNumberFormatter(termDataDraft.whatsapp)}</Stack.Item>
      </Stack.Item>
      <Stack.Item>
        <strong>Email:</strong> <Stack.Item> {termDataDraft.email} </Stack.Item>
      </Stack.Item>
      <Stack.Item>
        <strong>Endereço(s):</strong>
        <Stack.Item>
          {termDataDraft.street}, {termDataDraft.number} -{" "}
          {termDataDraft.neighborhood}, {termDataDraft.city} -{" "}
          {termDataDraft.uf} - {termDataDraft.zipCode}
          {termDataDraft.note && ` (${termDataDraft.note})`}
        </Stack.Item>
      </Stack.Item>
    </Card>
  );
}
